import React from "react";
import HeaderText from "../helpers/HeaderText";
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import {LISTS} from "../../components/config/index";
import { useNavigate } from "react-router-dom";
import './customslider.css'
export default function Collection() {
    const items = LISTS.LAYDYWEAR_CATEGORIES;
    let navigate = useNavigate();
    

    return (
    <>
        <HeaderText text="Our Collections"/>
        <div className="col-lg-12 col-md-12 col-sm-12 pt-0 pb-4" >
            <Swiper
                dir="rtl"
                modules={[EffectCoverflow, Navigation, Autoplay]}
                effect="coverflow"
                centeredSlides
                slidesPerView="auto"
                grabCursor
                loop
                initialSlide={0} // in RTL this is visually rightmost
                autoplay={{
                    delay: 2500,              // ms between transitions
                    disableOnInteraction: false,
                    reverseDirection: true,   // right → left
                    pauseOnMouseEnter: true,  // nice UX for hover
                }}
                coverflowEffect={{
                    rotate: 0,
                    stretch: 0,
                    depth: 0,
                    modifier: 0,
                    slideShadows: false,
                }}
                navigation
                speed={700}
            >

                {items.map((label, i) => (
                    <SwiperSlide key={i} style={{ width: 380,height: 300,position: 'relative' }}>
                        <img src={label.imageUrl} alt={label.text} style={{
                                width: '100%',
                                height: 300,
                                objectFit: 'cover',
                                display: 'block',
                                backfaceVisibility: 'hidden',
                                willChange: 'transform',
                            }}
                        />    
                        <div style={{position: 'absolute', bottom: '10px', left: '10px'}}> 
                            <button className="btn btn-two btn-white creative" onClick={()=>navigate(`/shop?category=${label.Name}`)}>
                                <span className="btn-wrap">
                                    <span className="text-first">{label.Name}</span>
                                </span>
                            </button>
                        </div> 
                    </SwiperSlide>
                ))}
            
            </Swiper>
        </div>
        
    </>
    );
}
